export enum Sizes {
  Small = 12,
  Medium = 16,
  Large = 24,
}

export type IconSizes = typeof Sizes[keyof typeof Sizes];
